// extracted by mini-css-extract-plugin
module.exports = {"crumb":"breadcrumbs_crumb__aN9tE","wrapper":"breadcrumbs_wrapper__n0b5V"};